import { create } from "zustand";
import { isDev } from "../utils/helpers";

const useDevManager = create((set, get) => ({
    IS_DEV: isDev()
}));

export default useDevManager;